<template>
  <div :class="[upgrade == true?'company_coment h278':'company_coment']">
    <div class="brief">
      <div class="portrait">
        <div style="position: relative">
          <div class="portrait_rus">
            <img class="portrait_img" :src="Info.headUrl" />
          </div>
          <div class="member">
            <div  v-if="vip == true"   class="exper_icon">
                <img  src="@/assets/images/compy_vip.png" alt="">
                <span>企业</span>
             </div>
          </div>
        </div>
        <div class="portrait_top" v-if="upgrade == true"  @click="onClick()">升级企业会员</div>
      </div>
      <div style="flex: 1; margin-left: 37px">
        <div class="brief_middle">
          <p>
            <span class="middle_title">{{Info.name}}</span>
            <span @click="onGrde()">{{ caculateCompanyStatus(Info.status) }}</span>
          </p>
           <p v-if="refunds == true"  class="midee_text" @click="onRefund()">申请退费</p>
          <!-- <button class="release" @click.prevent="onRelease()">我要发布</button> -->
        </div>
        <div class="brief_top">
          <p>
            <span>经营范围 :</span>
            <span class="brief_maert">{{Info.businessScope}}</span>
          </p>
          <p><span>联系电话 :</span>
            <span class="ml-8">{{Info.mobile }}</span></p>
          <p><span>电子邮箱 :</span><span class="ml-8"> {{Info.email}}</span></p>
          <p v-if="isTag == true " class="brief_vip" @click.prevent="onClick()">升级企业VIP会员享有更多福利</p>
        </div>
      </div>
    </div>
    <div class="expend_box">
      <div :class="[isButton?'expend_patrs ml-40':'expend_patrs m-l-6' ]">
        <span>总收入：</span>
        <span class="ml-13" style="color: #ff7402 ">￥</span>
        <span class="expan_font">{{balaInfo.total_income}}</span>
      </div>
      <div :class="[isButton?'expend_patrs ml-70':'expend_patrs m-l-14' ]">
        <span class="expend_font">余额</span>
        <span class="expend_fonts">￥{{balaInfo.balance}}</span>
      </div>
      <div :class="[isButton?'expend_patrs ml-70':'expend_patrs m-l-14' ]">
        <span>已提现：</span>
        <span class="expend_fonts ml-13">￥{{balaInfo.withdraw}}</span>
      </div>
      <div v-if="isButton == true" class="expend_comment">
        <button @click="dialogFormVisible = true" >充值</button>
        <button @click="onTest()">提现</button>
         <span v-if="cashoutper>0" :title="'满'+cashoutpoint+'元可提现,单次可申请提现'+cashoutper+'元'">满{{cashoutpoint}}元可提现</span>
         <span v-else>满{{cashoutpoint}}元可提现</span>
      </div>
    </div>

    <!--充值弹框，2021年12月14日10:45:54-->
    <el-dialog title="充值金额" :visible.sync="dialogFormVisible" width="35%">
      <el-form :model="info">
        <el-form-item label="充值金额" :label-width="formLabelWidth">
          <el-input v-model="info.amount" placeholder="自定义金额" autocomplete="off" style="position:relative;width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="快速充值" :label-width="formLabelWidth">
          <el-radio class="recharge" v-model="info.amount" label="10" border>10元</el-radio>
          <el-radio class="recharge" v-model="info.amount" label="20" border>20元</el-radio>
          <el-radio class="recharge" v-model="info.amount" label="50" border>50元</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="toRecharge">确 定</el-button>
      </div>
    </el-dialog>

    <!--退款协议弹框-->
     <div class="sett_dialog" v-show="dialogVisible">
        <div class="sett_cox"></div>
        <div class="sett_dialog_box">
          <div class="sett_matter">
            <p class="sett_title">退费协议</p>
            <p class="sett_jitr">
              <span v-if="!isImg">{{ time }}s</span>
              <img
                v-show="isImg"
                src="../assets/images/sign.png"
                @click.prevent="onText()"
              />
            </p>
          </div>
          <!-- <div class="sett_desc" v-html="issueStatement.des"></div> -->
        </div>
     </div>

     <div class="refund_dialog">
      <el-dialog
        title="提示"
        :visible.sync="dialogRefund"
        width="30%"
        center>
         <el-form ref="form" :model="form"  :rules="rules">
            <el-form-item prop="agree" class="fuck">
              <el-checkbox v-model="form.agree" name="checked"></el-checkbox>
              <div class="ml-8">
                我已阅读并同意《 <span class="agree" @click="settChange()">退费协议</span> 》
              </div>
            </el-form-item>
         </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogRefund = false">取 消</el-button>
          <el-button type="primary" @click="onForm('form')">确 定</el-button>
        </span>
      </el-dialog>
     </div>
  </div>
</template>
<script>
import {myfunds,sendrefund,getcashoutinfo,agreement,recharge} from '@/api/coment'
import {getSelfUserinfo} from '@/api/user'
export default {
  props: ["isButton"],
  data() {
    return {
      info:{
        amount: ""    //充值金额
      },
      dialogFormVisible:false,    //金额选择弹框
      statusList: ["待认证", "认证通过", "认证拒绝"],
      cashoutpoint:0,
      cashoutper:0,
      active:0,
      Info:{},
      balaInfo:{},
      vip:false,
      roleid:5,
      isTag:true,
      refunds:false,
      upgrade:false,
      status:'',
      dialogVisible:false,
      dialogRefund:false,
      isImg: false,
      time: 10,
      issueStatement: "",
      form:{
        agree:''
      },
      rules:{
        agree: [{ required: true, message: "请接受智污邦退款协议",trigger: "change"}]
      }
      };
  },
  created(){
    this.getcashoutctl();
    // this.getAgreement();
    if(this.$store.state.user.userInfo != null){
      this.Info = this.$store.state.user.userInfo.data;
      this.status =this.$store.state.user.userInfo.data.status;
      let obj = this.$store.state.user.userInfo.data2;
        switch(obj.id){
          case 4:
          this.upgrade = true;
          break;
          case 5:
          this.vip = true;
          this.isTag = false;
          this.refunds = true;
          this.upgrade = false;
          break;
        }
      this.getMyfunds();
    }
  },
  methods: {
    //企业认证状态
    caculateCompanyStatus(status) {
      if(status == null || status == -1){
        status = 0;
      }
      return this.statusList[status];
    },
    //获取提现参数
    getcashoutctl(){
        getcashoutinfo().then((res)=>{
          if(res.code == 0){
             for (let index = 0; index < res.page.length; index++) {
               let element = res.page[index];
               if("cashoutA1"== element.name){
                  this.cashoutper=element.cvalue
               }else if("cashoutPoint"== element.name){
                  this.cashoutpoint= element.cvalue;
               }
             }

          }
        })
    },
    //升级会员
    onClick() {
      if(this.status == 1){
        this.$emit("companyUpgrade",this.roleid);
        this.$router.push('/corporate_member')
      }else{
        this.$message({
          message:'认证通过后，才能升级哦!',
          type:'info',
          duration:2000
        });
      }

    },
    //提现
    onTest() {
      // if(this.balaInfo.balance >=50){
      //   this.$emit("withdrawal");
      // }else{
      //   this.$message({
      //      message:`满${this.cashoutpoint}元才可以提现`,
      //      type:'info'
      //   })
      // }

      getSelfUserinfo().then((res)=>{
        if(res.code == 0){
            if(res.data.status == 0){
              this.$alert('身份信息审核中，请稍后..','信息提示',{
                confirmButtonText: '确定',
                callback: action => {}
              })
            }else{
              if (res.data.idFront == "" || res.data.idBack == ""){
                this.$alert('请先完善身份信息','信息提示',{
                  confirmButtonText: '确定',
                  callback: action => {
                    this.$router.push({path:'/corporate_card'})
                  }
                })
              }else{
                if(this.balaInfo.balance >=this.cashoutpoint){
                  this.$emit('onWithdrawal')
                }else{
                  this.$message({
                  message:'满'+this.cashoutpoint+'元才可提现',
                  type:'warning',
                  duration:1000
                  })
                return false;
              }
              }
            }
        }
      })
    },
    //发布
    onRelease(){
      this.$emit('release')
    },
    //获取用户余额情况
    getMyfunds(){
      myfunds().then((res)=>{
        if(res.code ==0){
          this.balaInfo = res.data;
        }
      }).catch((err)=>{});
    },
    tranNumber(num){
      num = Number(num);
      if (num == 0) {
        return num + '';
      } else
      if (num > 1 && num < 10000) {
        return num + '';
      } else {
        return (num / 10000).toFixed(2) + '万';
      }
    },
    //查询退费协议
    getAgreement() {
      agreement()
        .then((res) => {
          this.issueStatement = res.page.filter((item) => item.name == "退费协议")[0];
        })
        .catch((err) => {});
    },
    //倒计时
    settChange() {
      // this.dialogRefund = false;
      this.dialogVisible = true;
      this.timer = setInterval(() => {
        this.time--;
        if (this.time == 0) {
          clearInterval(this.timer);
          this.isImg = true;
        }
      }, 1000);
    },
    //申请退费
    onRefund(){
      getSelfUserinfo().then((res)=>{
        if(res.code == 0){
            if(res.data.status == 0){
              this.$alert('身份信息审核中，请稍后..','信息提示',{
                confirmButtonText: '确定',
                callback: action => {}
              })
            }else{
              if (res.data.idFront == "" || res.data.idBack == ""){
                this.$alert('请先完善身份信息','信息提示',{
                  confirmButtonText: '确定',
                  callback: action => {
                    this.$router.push({path:'/corporate_card'})
                  }
                })
              }else{
                this.dialogRefund = true;
              }
            }
        }
      })
      // this.dialogRefund = true;
    },
    onText(){
      this.dialogVisible = false;
    },
    onGrde(){
       if(this.status == -1 || this.status == 0){
         this.$router.push('/corporate_attestation')
      }
    },
    onForm(formName){
       this.$refs[formName].validate((valid)=>{
         if(valid){
           sendrefund().then((res)=>{
            if(res.code ==0){
              this.$message({
                message:'等待审核',
                type:'info',
                duration:3000
              });
              this.dialogRefund = false;
            }
          }).catch((err)=>{})
          }else{
           return false;
         }
       });
    },

    // 充值
    toRecharge(){
      let params = {
        amount:this.info.amount
      }
      recharge(params)
        .then((res) => {
          this.orderNo = res.data.orderNo;
          if (res.code === 0) {
            // console.log("充值订单信息")
            // console.log(res)
            localStorage.setItem("list", JSON.stringify(res.data));
            localStorage.setItem("title", "智污邦环保服务平台账户余额充值");
            let url = window.location.href.split("//")[1];
            let host = window.location.host;
            let str = url.replace(host,"");
            str = str.substring(1);
            sessionStorage.setItem('url',str);
            this.$router.push({
              name: "payment"
            });
          }
        })
    },
  },
};
</script>
<style scoped>
.company_coment {
  width: 100% !important;
  border-left: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
  border-top: 2px solid #99cf2a;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 15px;
}
.h278{
  height: 278px;
}
.brief {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.portrait {
  margin-left: 38px;
  margin-top: 30px;
}
.portrait_rus {
  width: 149px;
  height: 149px;
  line-height: 149px;
  border-radius: 100%;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #999999;
}
.portrait_img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}
.member {
  position: absolute;
  top: 105px;
  right:0px;
  z-index: 100 !important;
  width: 60px;
}
.portrait_top {
  width: 149px;
  height: 30px;
  line-height: 30px;
  margin-top: 10px;
  background: linear-gradient(106deg, #18bbe9, #2866d2);
  border-radius: 15px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
}
.brief_middle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f2f2f2;
  padding: 10px 0px;
  margin-right: 30px;
}
.middle_title {
  height: 24px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  line-height: 38px;
  padding-bottom: 16px;
}
.brief_middle span:nth-child(2) {
  font-size: 12px;
  width: 59px;
  height: 24px;
  line-height: 24px;
  margin-left: 5px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9a9a9a;
  display: inline-block;
  border: 1px solid #eeeeee;
  border-radius: 3px;
  margin-bottom: -5px;
}
.brief_middle span:nth-child(2):hover{
  cursor: pointer;
}
.release {
  width: 114px;
  height: 35px;
  background: #68be32;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.brief_top {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.brief_top p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
}
.brief_top p:nth-child(1) {
  margin-top: 15px;
  display:flex;
  justify-content: flex-start;
}
.brief_maert{
  margin-left: 15px;
  width:80%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  height:41px;
}
.brief_top p:nth-child(2) {
  margin: 10px 0px;
}
.expend_box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  margin-top: 15px;
}
.expend_patrs{
  text-align: left;
}
.expend_font {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
}
.expend_fonts {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
}
.expan_font {
  font-size: 22px;
  font-family: Arial;
  font-weight: 400;
  color: #ff7402;
}
.expend_comment {
  /* position: absolute;
  display: flex;
  flex-direction: column;
  top: -25px !important;
  right: 33px !important; */
  width: 200px;
  position: absolute;
  /*display: flex;*/
  display: inline;
  flex-direction: column;
  top:-21px !important;
  right: 33px !important;
}
.expend_comment button {
  /* width: 114px !important;
  height: 35px !important;
  border-radius: 3px !important;
  color: #333333;
  background: #ffffff;
  border: 1px solid #333333; */
  width: 90px !important;
  height: 35px !important;
  border-radius: 3px !important;
  color: #333333;
  background: #ffffff;
  border: 1px solid #333333;
}
.expend_comment span {
  /* margin-top: 8px !important;
  font-size: 12px !important;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9a9a9a; */
   margin-top: 8px !important;
  font-size: 12px !important;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9A9A9A;
  float: right;
  margin-right: 13px;
}

.ml-30 {
  margin-left: 30px;
}
.ml-8{
  margin-left: 8px;
}
.ml-40{
  margin-left: 40px;
}

.ml-70{
  margin-left: 70px;
}
.ml-13{
  margin-left: -13px;
}
.m-l-6{
  margin-left:6%;
}
.m-l-10{
  margin-left: 10%;
}
.m-l-14{
  margin-left: 14%;
}

.midee_text{
  border: 1px solid #eeeeee;
  font-size: 12px;
  width: 58px;
  height: 25px;
  line-height: 25px;
  color: #9a9a9a;
  border-radius: 3px;
}
.midee_text:hover{
  cursor: pointer;
}

.exper_icon{
  position: relative;
}
.exper_icon img{
  /* width: 32px; */
  margin-right: -21px;
  margin-top: 10px;
}
.exper_icon span{
  font-size: 12px;
  color: #f4ea2a;
  position: absolute;
  width: 30px;
  top:25px;
  left: 41px;
}
.brief_vip{
  height: 25px;
  line-height: 25px;
  color: #FF4F4F !important;
  margin-top: 10px;
  display: inline-block;
  width: 200px;
}
.brief_vip:hover{
  cursor: pointer;
}

/**协议弹框 */
.sett_dialog{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  margin: 0;
  z-index: 2100;
}
.sett_dialog_box {
  width: 500px;
  height: 600px;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 3px;
  transform: translate(-50%, -50%);
  background: #ffffff;
  overflow: auto;
}
.sett_cox {
  position: fixed;
  left: 0;
  /* opacity: 0.3; */
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
  /* z-index:2003 !important; */
}
.sett_matter {
  position: relative;
  height: 50px;
}
.sett_title {
  font-size: 22px;
  color: #666666;
  height: 30px;
  line-height: 48px;
  text-align: center;
}
.sett_jitr {
  position: absolute;
  right: 20px;
  top: 10px;
}
.sett_jitr img {
  width: 20px;
  height: 20px;
}
/**协议弹框 */
.sett_dialog >>> .el-dialog {
  width: 500px;
  height: 600px;
}
.sett_dialog >>> .el-dialog__header {
  text-align: center;
}
.sett_dialog >>> .el-dialog__title {
  font-size: 24px;
}
.sett_desc {
  padding: 30px;
  font-size: 14px;
  line-height: 24px;
  color: #666666;
}
/deep/ .fuck .el-form-item__content {
  display: flex;
  align-items: center;
  margin-left: 60px;
}
.agree {
  cursor: pointer;
  color: #69cc1e;
}
.agree:hover {
  text-decoration: underline;
}



.dialog-footer>>>.el-button{
  width: 110px;
}
.dialog-footer>>>.el-button--default:hover{
  background-color: #ffffff !important;
  color: #606266;
  border-color: #DCDFE6;
}
.dialog-footer >>>.el-button--primary{
  background-color: #3bbb35;
  border: none;
}
.dialog-footer >>>.el-button--primary:hover{
  background-color: #3bbb35 !important;
  border: none;
}
</style>




// WEBPACK FOOTER //
// src/common/companySide.vue